import type { PropsWithChildren } from 'react';

import { FormField, FormInput, SubForm } from '@/_components';

import type { UseCreateEmail } from './use-create-email';

export function CreateEmail({ id, form, onSubmit, isPending, children }: PropsWithChildren<UseCreateEmail>) {
  return (
    <section className="col-span-12">
      <SubForm id={`create-email-${id}`} {...form} onSubmit={onSubmit} isSubmitting={isPending}>
        <FormField
          control={form.control}
          name="email"
          render={({ field: { value, onChange } }) => (
            <div className="flex w-full flex-1">
              <FormInput
                formItemClassName="flex-1"
                value={value}
                type="email"
                onChange={onChange}
                label="New Email"
                name="email"
                className="w-full flex-1"
                labelProps={{ className: 'w-[calc(100%_+_1.75rem)]' }}
              />
              {children}
            </div>
          )}
        />
      </SubForm>
    </section>
  );
}
